// src/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  UserData:[],
  UserActivy:[],
  UserId:"",
  UserState:false,
  showcomponents:0,
  PartnersData:[],
  PartnersDetailsData:[],
  Lvl:{
    Levels:"",
    LevelAmount:"",
    UserId:"",
  },
  ToastPartnerError:""
};
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData(state, action) {
      state.UserData = action.payload;
    },
    setUserActivy(state, action) {
      state.UserActivy = action.payload;
    },
    setUserId(state, action) {
      state.UserId = action.payload;
    },
    setUserState(state, action) {
      state.UserState = action.payload;
    },
    setshowcomponents(state, action) {
      state.showcomponents = action.payload;
    },
    setPartnersData(state, action) {
      state.PartnersData = action.payload;
    },
    setPartnersDetailsData(state, action) {
      state.PartnersDetailsData = action.payload;
    },
    setLvl(state, action) {
      state.Lvl = action.payload;
    },
  },
});

export const {
    setUserData,setUserActivy,setUserId,setUserState,setshowcomponents,setPartnersData,setPartnersDetails,setPartnersDetailsData,setLvl,setToastPartnerError
} = userSlice.actions;

export default userSlice.reducer;
